/* global setupVideoPlayer */
const playerSelector = '.video-player';

export class VideoInline {
  static isOnPage() {
    return $(playerSelector).length !== 0;
  }

  constructor() {
    this.init();
  }

  init() {
    $.each($(playerSelector), (index, player) => {
      const $player = $(player);
      const playerId = $player.attr('id') || `video-player-${index}`;

      if (!$player.attr('id')) {
        $player.attr('id', playerId);
      }

      const videoUrlHls = $player.data('video-url-hls');
      const videoUrlProgressive = $player.data('video-url-progressive');
      const $container = $player.closest('.inline-video-container');
      const $bgImage = $container.find('.video-player-bg-image');
      const srcset = $bgImage.data('srcset');
      const posterImage = srcset ? srcset.split(',')[0].trim().split(' ')[0] : '';
      const videoName = $player.data('video-name') || '';
      const autoplay = $player.data('video-autoplay') === true;
      const loop = $player.data('video-loop') === true;
      const mute = $player.data('video-mute') === true;
      const hideControls = $player.data('video-controls') === false;
      const videoUrl = videoUrlHls || videoUrlProgressive;

      setupVideoPlayer(playerId, {
        playlist: [{
          file: videoUrl,
          image: posterImage,
          title: videoName,
          description: ''
        }],
        autostart: autoplay,
        repeat: loop,
        mute: mute,
        controls: !hideControls,
        ga4analytics: true
      });
    });
  }
}